'use strict';

window.PinchZoom = require('core/thirdParty/pinchZoom/pinch-zoom.js');
var utils = require('../utils/utils');

const config = {
    pinchZoom: {
        draggableUnzoomed: false,
        minZoom: 1,
        maxZoom: 2.5,
        setOffsetsOnce: true
    }
};

const selectors = {
    carousel: '.js-carousel',
    modal: '.js-modal, .modal'
};

/**
 * Handles very specific small functionalities
 */

module.exports = {
    // Global slick init, the configuration parameters are passed in the data-slick attribute in isml
    slickInit: () => { $(selectors.carousel).slick(); },
    recommendationsStart: () => {
        $(document).on('recommendations:start', () => {
            $(`${selectors.carousel}:not(.slick-initialized)`).slick();
        });
    },

    //Countdown timer for page designer component
    countdownTimer: () => {
        var countdownTimers = $('.promo-4 .countdownTimer, .promo-5 .countdownTimer');
        countdownTimers.each(function(){
            var countdownTimer = $(this);
            var countdownDate = countdownTimer.attr('data-date');
            countdownDate = new Date(countdownDate).getTime();

            var now = new Date().getTime();
            var distance = countdownDate - now;

            if(distance <= 0){
                countdownTimer.remove();
                return false;
            }

            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);

            var tickerDays = countdownTimer.find('#days .number');
            var tickerHours = countdownTimer.find('#hours .number');
            var tickerMinutes = countdownTimer.find('#mins .number');
            var tickerSeconds = countdownTimer.find('#secs .number');

            tickerDays.html(days);                
            tickerHours.html(hours);
            tickerMinutes.html(minutes);
            tickerSeconds.html(seconds);

            if(days == 1) {
                var tickerDaysTitle = countdownTimer.find('#days .title');
                tickerDaysTitle.html('DAY');
            }

            if(hours == 1) {
                var tickerHoursTitle = countdownTimer.find('#hours .title');
                tickerHoursTitle.html('HR');
            }

            countdownTimer.addClass('show');

            var intervalSeconds  = setInterval(function(){
                now = new Date().getTime();
                distance = countdownDate - now;
                minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                seconds = Math.floor((distance % (1000 * 60)) / 1000);
                tickerMinutes.html(minutes);
                tickerSeconds.html(seconds);
            }, 1000);

        });
    },

    //hero carousel for page designer components
    //needs to loop through all available carousels and set adapative heights
    heroCarousel: () => {
        var heroCarousels = $('.js-heroCarousel');
        heroCarousels.each(function(){
            var heroCarousel = $(this);

            var speed = parseInt(heroCarousel.data('transition-speed')*1000);
            var transitionType = heroCarousel.data('transition-type') == 'fade' ? true : false;
            var autoplay = heroCarousel.data('autoplay') == 'on' ? true : false;
            var showNav = heroCarousel.hasClass('showNav') ? true : false;

            var options = {
                dots: showNav,
                arrows: false,
                autoplay: autoplay,
                autoplaySpeed: speed,
                infinite: false,
                speed: 300,
                fade: transitionType,
                pauseOnHover: false
            };
      
            heroCarousel.on('beforeChange', function() {
                adaptiveHeight(this);
            }).slick(options);
      
            function adaptiveHeight(slider) {
                var slickTrack = $(slider).find('.slick-track');
                var activeSlide = $(slider).find('.slick-active');
                var nextSlide = $(activeSlide).next();
                if(nextSlide.length == 0) {
                    nextSlide = $(slider).find('.slick-slide').first();
                }
                var nextSlideHeight = nextSlide.find('.pd-hero').outerHeight(true);
                slickTrack.height(nextSlideHeight);
            }
        
            $(window).on('resize', function() {
                multiSlideAdaptiveHeight(heroCarousel);
            });
        }); 
    },

    onModalHide: () => {
        $(selectors.modal).on('hidden.bs.modal', (e) => {
            const thatModal = e.delegateTarget;

            // Unslick slider if it has one
            const innerCarousel = $(thatModal).find(selectors.carousel);

            if (innerCarousel.length) {
                innerCarousel.slick('unslick');
            }
        });
    },

    onModalShow: () => {
        $(selectors.modal).on('shown.bs.modal', (e) => {
            const thatModal = e.delegateTarget;

            // Init slider if it has one
            const innerCarousel = $(thatModal).find(selectors.carousel);

            if (innerCarousel.length && !innerCarousel.hasClass('slick-initialized')) {
                innerCarousel.slick();
            }
        });
    },

    productTile: () => {
        /*
        $('.main').on('mouseenter', '.js-tile-image', function () {
            let $image = $(this);
            if ($image.data('alt-src') && !$image.hasClass('error')) {
                $image.data('primary-src', $image.attr('src'));
                $image.attr('src', $image.data('alt-src'));
            }
        }).on('mouseleave', '.js-tile-image', function () {
            let $image = $(this);
            if ($image.data('primary-src') && ($image.attr('src') !== $image.data('primary-src'))) {
                $image.attr('src', $image.data('primary-src'));
            }
        });
        */
    },

    globalEventHandlers: () => {
        // events that should be run only once

        // Trigger error event on all ajax calls.
        $(document).ajaxError(function (event, jqxhr) {
            if (window.pushGAEvent && jqxhr.responseJSON && jqxhr.responseJSON.dataLayerViewData) {
                window.pushGAEvent(
                    jqxhr.responseJSON.dataLayerViewData.event,
                    jqxhr.responseJSON.dataLayerViewData.dataLayerData
                );
            }
        });

        if (utils.isTouchDevice()) {
            utils.smartResize(() => {
                // fix resize bug
                $('.js-pinch-zoom').each((_, item) => {
                    let $parent = $(item).parent();
                    if ($parent.hasClass('pinch-zoom-container')) {
                        $parent.height($(item).height());
                    }
                });
            });
        }
    },

    initPinchZoom: () => {
        if (utils.isTouchDevice()) {
            const pinchZoomElements = document.querySelectorAll('.js-pinch-zoom');

            pinchZoomElements.forEach((item) => {
                if (!item.parentElement.classList.contains('pinch-zoom-container')) {
                    // eslint-disable-next-line
                    new window.PinchZoom.default(item, config.pinchZoom);
                }
            });
        }
    }
};
